


































import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Action} from "vuex-class";
import {IvrMenuFilter} from "@/store/call/ivr_menus/types";
import BaseFilter from "@/components/Filter/BaseFilter";
import {notifyError} from "@/utils/notify-helper";
import {getTranslatedParams} from "@/utils/notify-utils";
import { NumberWings, InputWings } from "wings-ui-components";

@Component({components: {NumberWings, InputWings}})
export default class CallIvrMenusFilter extends BaseFilter<IvrMenuFilter> {
  @PropSync('show') is_show!: boolean;
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;

  @Action("getIvrMenus") actionGetIvrMenus: any;

  defaultFilter(): IvrMenuFilter {
    return {
      name: undefined,
      page_number: 1
    }
  }

  created() {
    this.actionGetIvrMenus(this.filter);
    this.scroll();
    this.filtered();
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "IVR menu",
        addititional_info: getTranslatedParams(this.filter)
      };
      const resp = await this.actionGetIvrMenus(this.filter);
      this.is_last = resp.length == 0;
      await this.actionLog(this.logObject);
    } catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: IvrMenuFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
